/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_Download_TitleInputs */



/**
* | output |
* | --- |
* | "Download Preview" |
*
* @param {Image_Export_Magnified_Download_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_download_title = /** @type {((inputs?: Image_Export_Magnified_Download_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Download_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Telecharger la previsualisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica l'anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр загрузки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar vista previa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューをダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन डाउनलोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixar pré-visualização")
	return /** @type {LocalizedString} */ ("Download Preview")
});